import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const VoucherCreate = lazy(() =>
  import("@scenes/PromotionCodes/components/VoucherCreate").then((module) => ({
    default: module.VoucherCreate,
  }))
);

export const promotionCodeCreateNRO: NavigationRoutingObject = {
  Component: VoucherCreate,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => {
    return t("promotion-code-create-nro-heading", "Create Promotion Code");
  },
  pageNameForTracking: () => "Create Promotion Code",
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/vouchers/new/:appGroupId",
};
